module.exports = __webpack_public_path__ + "img/AD.d42b20dc.png";